
export const WINDOW_SIZE_CHANGED = 'WINDOW_SIZE_CHANGED';

export const windowSizeChanged = ( params ) => dispatch => {
  dispatch({ type: WINDOW_SIZE_CHANGED, ...params });
};
